import React from "react"
import moment from "moment"

// import Tags from "../../common/tags/Tags"
// import TagItem from "../../common/tags/TagItem"
import BackgroundImage from "../../common/BackgroundImage"
import ClusterStatusButton from "../ClusterStatusButton"

const ClusterListItem = ({
    id,
    activeId,
    title,
    articleCount,
    time,
    image_url,
    status,
    onClick
}) => (
    <div
        className={`list-group-item${
            activeId === id ? " active" : ""
        } source-list-item`}
        onClick={onClick ? onClick(id) : null}
    >
        <BackgroundImage
            classList={["list-group-item-thumb"]}
            imageUrl={image_url}
            isThumbnail={true}
        />
        <div className="list-group-item-content">
            <h4>{title}</h4>
            <p>{articleCount} articles</p>
            <p>{moment.unix(time).format("llll")}</p>
            <ClusterStatusButton active={status === "Active"} />
        </div>
    </div>
)

export default ClusterListItem
